//Construye un mini-diagrama SVG (string) de la posición de una ubicación dentro de su rack
export const construirSvgMiniRack = ({
  numeroColumnas = 1,
  numeroNiveles = 1,
  columna,
  nivelRack,
  ancho = 140,
  alto = 90,
  colorResaltado = "#f97316",
}) => {
  const cols = Math.max(1, Number(numeroColumnas) || 1);
  const nivs = Math.max(1, Number(numeroNiveles) || 1);
  const MARGEN = 4;
  const w = ancho - MARGEN * 2;
  const h = alto - MARGEN * 2;

  const partes = [
    `<rect x="${MARGEN}" y="${MARGEN}" width="${w}" height="${h}" fill="#fafbfc" stroke="#cbd2e0" stroke-width="1" />`,
  ];

  const colValida = columna >= 1 && columna <= cols;
  const nivValido = nivelRack >= 1 && nivelRack <= nivs;
  const mostrarCuadricula = cols * nivs <= 144;

  if (mostrarCuadricula) {
    const cw = w / cols;
    const ch = h / nivs;
    for (let c = 1; c <= cols; c++) {
      for (let n = 1; n <= nivs; n++) {
        const x = MARGEN + (c - 1) * cw;
        const y = MARGEN + (nivs - n) * ch; 
        const esDestino = colValida && nivValido && c === columna && n === nivelRack;
        partes.push(
          `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${cw.toFixed(1)}" height="${ch.toFixed(1)}" fill="${
            esDestino ? colorResaltado : "#ffffff"
          }" stroke="#e2e6ee" stroke-width="0.5" />`
        );
      }
    }
  } else if (colValida && nivValido) {
    const cx = MARGEN + ((columna - 0.5) / cols) * w;
    const cy = MARGEN + ((nivs - nivelRack + 0.5) / nivs) * h;
    const radio = Math.max(3, Math.min(w, h) * 0.04);
    partes.push(`<circle cx="${cx.toFixed(1)}" cy="${cy.toFixed(1)}" r="${radio}" fill="${colorResaltado}" />`);
  }

  return `<svg width="${ancho}" height="${alto}" xmlns="http://www.w3.org/2000/svg">${partes.join("")}</svg>`;
};

export const posicionRackTexto = (insumo) => {
  if (!insumo) return null;
  if (insumo.claveUbicacion) {
    const nombreDistinto = insumo.nombreUbicacion && insumo.nombreUbicacion !== insumo.claveUbicacion;
    return insumo.claveUbicacion + (nombreDistinto ? ` - ${insumo.nombreUbicacion}` : "");
  }
  const desgloseRack = [];
  if (insumo.rackCodigo) desgloseRack.push(`Rack ${insumo.rackCodigo}`);
  else if (insumo.numeroRack) desgloseRack.push(`Rack ${insumo.numeroRack}`);
  if (insumo.columna != null) desgloseRack.push(`C${insumo.columna}`);
  if (insumo.nivelRack != null) desgloseRack.push(`N${insumo.nivelRack}`);
  if (insumo.profundidad != null && insumo.profundidad > 1) desgloseRack.push(`P${insumo.profundidad}`);
  return desgloseRack.length ? desgloseRack.join(" · ") : null;
};

export const puedeDibujarMiniRack = (insumo) =>
  !!(insumo?.rackNumeroColumnas > 0 && insumo?.rackNumeroNiveles > 0 && insumo?.columna != null && insumo?.nivelRack != null);
